<template>
    <div class="table-responsive mt-0">
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <table ref="table" class="w-100">
            <thead>
                <tr>
                    <th
                        v-for="head in headers"
                        :key="head"
                    >
                        {{ head }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in data">
                    <td
                        v-for="column in dataRows"
                        :key="column"
                    >
                        <template v-if="getLink(row, column)">
                            <a :href="getLink(row, column)">{{ translate(row[column], column) }}</a>
                        </template>
                        <template v-else>
                            {{ translate(row[column], column) }}
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import UiSpinner from '../ui/spinner.vue';

export default {
    name: 'WidgetDataTable',
    components: {
        UiSpinner,
    },
    props: {
        columns: {
            type: Array,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: [],
            isLoading: true,
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...mapState('dashboard', [
            'query',
        ]),

        dataRows() {
            return this.columns.map(column => column.data);
        },

        headers() {
            return this.columns.map(column => column.title);
        },
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const { data: { data } } = await axios.get(this.url, { params: this.query });

            this.data = data;
            this.isLoading = false;
        },

        getLink(row, column) {
            if (column === 'amount' && row.url) {
                return row.url;
            } else if (column === 'patients' && row.url_mq_false) {
                return row.url_mq_false;
            } else if (column === 'below_cut_off' && row.url_mq_true) {
                return row.url_mq_true;
            }
            return null;
        },

        translate(value, columnName) {
            const column = this.columns.find(column => column.name === columnName);

            if (!column.translate) {
                if (Number.isFinite(value)) {
                    return this.formatNumber(value);
                }

                return value;
            }

            return this.$t(column.translate + value);
        }
    },
    watch: {
        query() {
            this.fetch();
        },
    },
};
</script>
